import {bindable, bindingMode, customElement, inject} from 'aurelia-framework';
import {ValidationController, ValidationControllerFactory, ValidationRules} from 'aurelia-validation';
import {EventAggregator, Subscription} from 'aurelia-event-aggregator';
import {findIndex} from 'lodash';

@customElement('multiple-contacts-input')
@inject(Element, ValidationControllerFactory, EventAggregator)
export class MultipleContactsInput {
  @bindable({
    defaultBindingMode: bindingMode.twoWay
  }) contactList = [];
  @bindable groupId;

  validCF: ValidationController;
  emailEntered: string = '';
  emailError: boolean = false;
  displayInfo: boolean = false;
  subscribeDeleteEmail: Subscription;

  constructor(public element: Element, validCF: ValidationControllerFactory, public ea: EventAggregator) {
    this.validCF = validCF.createForCurrentScope();

    //email validation
    ValidationRules
      .ensure('emailEntered').required().email().matches(new RegExp(/\.[a-zA-Z]+$/))
      .on(this);
  }

  attached() {
    if (this.emailError) {
      // @ts-ignore
      this.emailError.style.display = 'none';
    }
    this.subscribeDeleteEmail = this.ea.subscribe('DSSB:ea-box-delete-pressed', (msg) => {
      if (msg.event && msg.event.target.nodeName !== 'INPUT') {
        this.removeEmails();
      }
    });
  }

  detached() {
    this.subscribeDeleteEmail.dispose();
  }

  addEmail(e) {
    if (e && e.currentTarget) {
      let emailVal = e.target.value;
      if(emailVal !== '' &&  findIndex(this.contactList, {email: emailVal}) < 0 ) {
        this.validCF.validate().then((results)=> {
          if (results.valid) {
            this.contactList.push({ id: '', text: emailVal, title: emailVal, email: emailVal, selected: false});
            e.target.value = '';
            this.emailError = false;
          } else {
            this.emailError = true;
            setTimeout(()=>{
              this.emailError = false;
            }, 4000);
          }
        });
      }
    }
  }

  removeEmails() {
    for (let i = 0; i < this.contactList.length; i++) {
      if (this.contactList[i].selected) {
        this.contactList.splice(i, 1);
        i--;
      }
    }
  }
  removeEmail(i) {
    this.contactList.splice(i, 1);
  }
  addUser(user) {
    if (user) {
      if (this.emailError) {
        this.emailError = false;
      }
      if (!this.contactList.some(o => o.id === user.id)) {
        this.contactList.push({
          id: user.id,
          text: user.fullname,
          title: user.email,
          email: user.email,
          selected: false
        });
      }
    }
  }
  showInfo(e) {
    this.displayInfo = !this.displayInfo;
  }

  cleanSelection(e) {
    while (findIndex(this.contactList, {selected: true}) >=  0) {
      this.contactList[findIndex(this.contactList, {selected: true})].selected = false;
    }
  }
}
